import { toObjectMap } from "../utilities/dictionary";

const PORTRAIT = "PORTRAIT";
const LANDSCAPE = "LANDSCAPE";
const SQUARE = "SQUARE";

type PORTRAIT = typeof PORTRAIT;
type LANDSCAPE = typeof LANDSCAPE;
type SQUARE = typeof SQUARE;

const orientations = [PORTRAIT, LANDSCAPE, SQUARE] as const;
type Orientation = (typeof orientations)[number];
const orientationsMap = toObjectMap<Orientation>([...orientations]);

export { LANDSCAPE, orientations, orientationsMap, PORTRAIT, SQUARE };
export type { Orientation };
